/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request to set the module-wide autograde-on-submission flag.

Carries no version: autograde-on-submission is operational grading config applied
module-wide (across all versions), editable by the owner in any workflow state.
 */
export interface AutogradeOnSubmissionRequest {
  enabled: boolean;
}
